import { IStackStyles, Stack } from "@fluentui/react";
import React from "react";
import {sidePaneMobileStyles, sidePaneStyles } from "../styles";

interface SidePaneProps {
    /** If true shows SidePane as fullscreen overlay (at the top of main content). Otherwise SidePane looks like a second column in the page layout.*/
    isOverlay: boolean;
    isOpen: boolean;
    children: React.ReactNode;
    header?: string;
    width?: string; 
}

export const SidePane = (props: SidePaneProps): JSX.Element => {
    const { isOverlay, isOpen, header, width } = props;

    const paneStyles = sidePaneStyles(width);
    const paneMobileStyles = sidePaneMobileStyles();


    const paneContainerMobileStyles: IStackStyles = {
        root: {
            width: '100vw',
            height: '100%',
            maxHeight: '100vh',
            margin: 0,
            padding: 0,
            position: 'absolute',
            zIndex: 9999,
            '[data-ui-id="SidePane"]': {
                padding: 0,
            },
        }
    };

    return (
        <Stack hidden={!isOpen} styles={ isOverlay ? paneContainerMobileStyles : undefined } verticalFill>
            <Stack verticalFill  styles={ isOverlay ? paneMobileStyles : paneStyles } data-ui-id="SidePane">
                {header && <h2>{ header }</h2>}
                {props.children}
            </Stack>
        </Stack>
    );
};
